import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logo_outline.svg'


const _hoisted_1 = { id: "home" }
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-dark" }
const _hoisted_3 = { class: "container-fluid pl-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode(" H.E.R.O.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "menu-icon navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarOnMobile",
  "aria-controls": "navbarNavAltMarkup",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_6 = {
  class: "collapse navbar-collapse text-center",
  id: "navbarOnMobile",
  ref: "navbarOnMobile"
}
const _hoisted_7 = { class: "navbar-nav ms-auto" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  id: "langDropdown",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_11 = {
  class: "dropdown-menu",
  "aria-labelledby": "langDropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Waypoint = _resolveComponent("Waypoint")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Waypoint, { onChange: _ctx.onchange }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["nav-wrap", [ _ctx.isTop? _ctx.isHome? 'nav-bg-tran': 'nav-background': 'nav-bg-grey' ]]),
            id: "nav"
          }, [
            _createElementVNode("nav", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('SECTION_TITLES'), (navItem) => {
                      return (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: navItem.LINK,
                          onClick: _ctx.closeNavbar
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(navItem.TITLE), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "onClick"])
                      ]))
                    }), 256)),
                    _createElementVNode("li", _hoisted_9, [
                      _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('LANG_BTN')), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en')))
                        }, "English"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('tw')))
                        }, "中文"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('jp')))
                        }, "日本語")
                      ])
                    ])
                  ])
                ], 512)
              ])
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["onChange"]),
      _createVNode(_component_RouterView, { class: "router-view" })
    ]),
    _createVNode(_component_Footer)
  ], 64))
}